import List from "@/components/list";
import router from "@/router";

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const deleteCdn = listeners["delete"] || function() {};
  const updateTime = listeners["update-time"] || function() {};
  const isShowDeptLevel = props.isShowDeptLevel;
  function handleDelete({ row }) {
    deleteCdn({uuids: [row.uuid]});
  }
  function handleUpdate({ row }) {
    updateTime(row);
  }
  const Deal = ({ props: { vo } }) => {
    const canEdit = vo.row.cdnStatus == 1;
    const dealConf = [
      [
        canEdit ? "icon-edit" : "icon-edit-disable",
        "修改失效时间",
        () => { canEdit ? handleUpdate(vo) : null },
        "cdnRecord:update",
      ],
      [
        canEdit ? "icon-delete" : "icon-delete-disable",
        "删除",
        () =>{ canEdit ? handleDelete(vo) : null },
        "cdnRecord:delete",
      ],
    ];
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const VideoName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span
        class="blue_text"
        onClick={() => {
          router.push({
            path: "/video/detail",
            query: { id: item.videoUuid },
          });
        }}
      >
        {item.videoName}
      </span>
    );
  };

  function selectable(row, index) {
    return row.cdnStatus == 1;
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      selectable: selectable
    },
    {
      label: "视频名称",
      prop: "videoName",
      minWidth: "240",
      showOverflowTooltip: true,
      render: vo => <VideoName vo={vo} />
    },
    {
      label: "有效时间",
      prop: "workTimeStr",
      minWidth: "150",
    },
    {
      label: "生效状态",
      prop: "cdnStatusStr",
      minWidth: "80",
    },
    {
      label: "上线状态",
      prop: "onlineStatusStr",
      minWidth: "80",
    },
    {
      label: "展示终端",
      prop: "showTypeName",
      minWidth: "150",
    },
    {
      label: "更新时间",
      prop: "configTimeStr",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      minWidth: "80",
      fixed: "right",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  if (isShowDeptLevel) {
    AccountTableConfig.splice(-2, 0, {
      label: "所属学院",
      prop: "deptName",
      minWidth: "120",
      showOverflowTooltip: true,
    });
  }
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
